"use client";

import React, { useState, useEffect } from "react";

/**
 * MathComponent를 클라이언트 사이드에서만 로드하는 래퍼 컴포넌트
 * SSR에서 window 객체가 없어 발생하는 에러를 방지하기 위해 동적 import 사용
 */
export function EquationRenderer({
  tex,
  inline = false,
}: {
  tex: string;
  inline?: boolean;
}) {
  const [MathComponent, setMathComponent] = useState<React.ComponentType<{
    tex: string;
    display?: boolean;
  }> | null>(null);

  useEffect(() => {
    // 클라이언트 사이드에서만 동적으로 import
    import("./mathjax-component").then(module => {
      setMathComponent(() => module.MathComponent);
    });
  }, []);

  // inline은 문단 텍스트에 섞인 수식($...$)이라 block 레이아웃(mx-auto flex p-2)을 쓰지 않는다.
  const wrapperClass = inline ? "inline-block align-middle" : "mx-auto flex p-2";

  if (!MathComponent) {
    // 로딩 중이거나 SSR에서는 원본 delimiter를 유지한 텍스트로 표시
    let fallback = "";
    if (tex) {
      fallback = inline ? `$${tex}$` : `$$${tex}$$`;
    }
    return <span className={wrapperClass}>{fallback}</span>;
  }

  return (
    <span className={wrapperClass}>
      <MathComponent tex={tex} display={!inline} />
    </span>
  );
}
